export enum PaymentRepeatType {
  Daily = 0,
  Weekly = 1,
  Monthly = 2,
  Yearly = 3,
  Cron = 4,
  Minutely = 5,
  Hourly = 6
}
